import { CSSProperties } from 'react';

export const errorMessageTextStyleOverride: CSSProperties = {
  position: 'relative',
  textAlign: 'left',
  display: 'inline-block',
};
